/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPaymentsV1AchState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PAYMENTS_V1_ACH_STATE_ENTITY_NAME = 'ixc.payments.v1.Ach';
export const ixcPaymentsV1AchStateEntity = new schema.Entity<IxcPaymentsV1AchState>(IXC_PAYMENTS_V1_ACH_STATE_ENTITY_NAME, {}, { idAttribute: 'achId' });

